import Divider from 'components/styles/general-elements/Divider';
import React, { useRef } from 'react';
import { Article } from 'src/types/sanity/schema';
import { fyShuffle } from 'utils/arrayFunctions';
import ArticleContent from './ArticleContent';
import ArticleMeta from './ArticleMeta';
import { JournalPageStyles } from './JournalStyles';
import Pagination from './Pagination';
import RelatedStories from './RelatedStories';

// const SocialWidgetsNoSSR = dynamic(() => import('../Layout/social/SocialWidgets'), { ssr: false });
/**
 * Maybe this should be used a "Quick view Component/Modal?"
 */

interface Props {
    // queryId?: string | string[];
    article: Article;
    relatedArticles?: Article[];
}

const JournalPage: React.FC<Props> = ({ article, relatedArticles }) => {
    // const router = useRouter();

    // const [hideOnScroll, setHideOnScroll] = useState(true);

    // useScrollPosition(
    //     ({ prevPos, currPos }) => {
    //         if (isBrowser) {
    //             const height = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    //             const isScrollingUp = currPos.y > prevPos.y;
    //             const isScrollingDown = currPos.y < prevPos.y;

    //             if (height + currPos.y <= 300) {
    //                 setHideOnScroll(true);
    //             } else if (isScrollingUp && currPos.y <= -400) {
    //                 setHideOnScroll(false);
    //             } else if (isScrollingUp !== hideOnScroll) setHideOnScroll(isScrollingUp);
    //         }
    //     },
    //     [hideOnScroll],
    // );

    if (!article || !article) return <p>Loading ...</p>;

    // function filterArticleSections(article: getArticleByUri['article']) {
    //     if (!article || !article.journalArticle) return null;
    //     const { journalArticle } = article;
    //     const articleSections = Object.values(journalArticle);

    //     return articleSections;
    // }

    const { title, mainImage, body } = article;
    // const featuredImage = urlFor(mainImage).url();
    const currRelatedArticleRef = useRef(relatedArticles ? fyShuffle(relatedArticles)[0] : { current: null });
    return (
        <JournalPageStyles className="full-bleed">
            {article && (
                <>
                    <ArticleMeta
                        article={article}
                        isSingle
                        relatedArticle={relatedArticles ? currRelatedArticleRef.current : undefined}
                    />
                    <ArticleContent content={body} />
                    <Pagination prevArticle={article['previousArticle']} nextArticle={article['nextArticle']} />
                    {!!relatedArticles?.length ? (
                        <>
                            <RelatedStories articles={relatedArticles} />
                            <Divider size={{ top: 'm', bottom: 'none' }} />
                        </>
                    ) : null}
                </>
            )}
        </JournalPageStyles>
    );
};

export default JournalPage;
